"use client";

import React from "react";
import Button, { ButtonSize, ButtonVariant } from "@/app/(components)/generics/Button/Button";
import ErrorMessage from "@/app/(components)/generics/messages/ErrorMessage/ErrorMessage";
import { ConfirmStore } from "@/app/stores/ConfirmStore";
import { TKey } from "@/app/translations/TKey";
import { T } from "@/app/translations/Translations";
import { DefaultProps } from "@/app/types/DefaultProps";
import { UStyles } from "@/app/utils/UStyles";
import styles from "./Confirm.module.css";

type Props = DefaultProps & {};

export default function Confirm(props: Props) {
  const { lang } = props.params;

  const isOpen = ConfirmStore((state) => state.isOpen);
  const loading = ConfirmStore((state) => state.loading);
  const title = ConfirmStore((state) => state.title);
  const message = ConfirmStore((state) => state.message);
  const confirmLabel = ConfirmStore((state) => state.confirmLabel);
  const error = ConfirmStore((state) => state.error);
  const confirm = ConfirmStore((state) => state.confirm);
  const close = ConfirmStore((state) => state.close);

  const handleBackgroundClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      close();
    }
  };

  return (
    <div
      className={UStyles.classNames(styles.background, !isOpen ? styles.closed : "")}
      onPointerDown={handleBackgroundClick}
    >
      <div className={styles.box}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.message}>{message}</p>
        {error && <ErrorMessage message={error} />}
        <div className={styles.actions}>
          <Button variant={ButtonVariant.SECONDARY} size={ButtonSize.SM} onClick={close}>
            {T(TKey.CANCEL, lang)}
          </Button>
          <Button
            variant={ButtonVariant.DANGER}
            size={ButtonSize.SM}
            loading={loading}
            onClick={confirm}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
